export default {
  currentFiltersDefaultTitle: {
    id: 'CURRENT_FILTERS_DEFAULT_TITLE',
    defaultMessage: 'Current Filters',
    description: 'Title for the header of the added filters',
  },
  applyToAllDefaultLabel: {
    id: 'APLY_TO_ALL_DEFAULT_LABEL',
    defaultMessage: 'Apply Filters to all Widgets',
    description: 'Label for the apply filters to all widgets checkbox',
  },
  applyToAllDefaultCaption: {
    id: 'APLY_TO_ALL_DEFAULT_CAPTION',
    defaultMessage: 'Reset all widgets on dashboard',
    description: 'Caption for the apply filters to all widgets checkbox',
  },
};
